module.exports = require("./vai.d.ts");